import GridColumnInputWrapper from '@components/common/GridColumnInputWrapper';
import { Card } from 'semantic-ui-react';
import styles from '../styles/Activity.module.scss';
import { UseFormRegisterReturn } from 'react-hook-form';
import TextArea from '@components/common/TextArea';

type Props = {
  header: string;
  text?: string;
  setText?: (text: string) => void;
  disabled?: boolean;
  formregistor: UseFormRegisterReturn;
  error?: string;
};

const TextField = ({ header, text, setText, disabled, formregistor, error }: Props) => {
  return (
    <Card className={styles.cardText}>
      {header != null && <div className={styles.activityTextHeader}>{header}</div>}
      <div className={styles.inputWrapper}>
        <div className={styles.errorMessage}>{error}</div>
        <GridColumnInputWrapper
          render={(props: any) => (
            <TextArea
              register={formregistor}
              disabled={disabled}
              value={text}
              rows={3}
              onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
                setText?.(e.target.value);
                formregistor.onChange(e);
              }}
            />
          )}
        />
      </div>
    </Card>
  );
};

export default TextField;
